import { Button, Flex, Heading, Image, Text } from '@chakra-ui/react';
import { SliceComponentProps } from '@prismicio/react';
import React from 'react';
import { HeroTextContent } from '../../Hero';
import Link from '../../Link';

const TopCapabilitiesHeroSlice = (props: TopCapabilitiesHeroSliceType) => {
  const data = props.slice.primary;
  const hasHeroImage = data.hero_image && data.hero_image.url;
  const vertical = props.slice.primary.vertical;

  return (
    <>
      <Flex
        flexDir={{ lg: vertical ? 'column' : 'row', base: 'column' }}
        gridGap={{base: vertical ? '30px' : '60px'}}
        p='0'
        paddingTop={{ lg: '80px', base: '80px' }}
        mb={{ base: '0', md: '20px', lg: '70px' }}
        w='100%'
      >
        <HeroTextContent
          display='flex'
          flexDirection='column'
          justifyContent='flexStart'
          maxW={vertical ? '890px' : '540px'}
        >
          <Heading
            fontSize={{ base: '36px', lg: '52px' }}
            size='h1'
            as='h1'
            lineHeight='125%'
            color='blue.700'
          >
            {data.hero_title}
          </Heading>
          <Text
            fontWeight='400'
            fontSize={{ base: '16px', lg: '24px' }}
            marginTop='8px'
            color='gray.900'
            marginBottom='0'
          >
            {data.hero_body}
          </Text>
          {props.slice.items.length > 0 && (
            <Flex marginTop='24px' gridGap='20px'>
              {props.slice.items.map((item, index) => (
                <Link to={item.hero_button_link} key={index}>
                  <Button variant={item.hero_button_variant} p='12px 20px'>
                    <Heading
                      size='h5'
                      fontWeight='600'
                      color={
                        item.hero_button_variant === 'blueHollowTint'
                          ? 'pdftron'
                          : 'unset'
                      }
                    >
                      {item.hero_button_label}
                    </Heading>
                  </Button>
                </Link>
              ))}
            </Flex>
          )}
        </HeroTextContent>
        {hasHeroImage && (
          <Flex w='100%'>
            <Flex
              w={{
                lg: vertical ? '1090px' : '598px',
                base: vertical ? 'unset' : '318px',
              }}
              pos='relative'
              grow={1}
            >
              <Image
                src={data.hero_image.url}
                w='100%'
                objectFit='cover'
                draggable='false'
                alignSelf='center'
                alt={data.hero_image.alt}
              />
            </Flex>
          </Flex>
        )}
      </Flex>
    </>
  );
};

export type TopCapabilitiesHeroSliceType = SliceComponentProps<{
  id: string;
  items?: {
    hero_button_label: string;
    hero_button_link: string;
    hero_button_variant?: string;
  }[];
  primary: {
    hero_image: {
      url?: string;
      alt?: string;
    };
    hero_body?: string;
    hero_title?: string;
    vertical: boolean;
  };
  slice_type: string;
}>;

export default TopCapabilitiesHeroSlice;
